import FirstFixingDate from '@/App/tiles/ForwardAccumulator/parts/RightPanel/common/FirstFixingDate.tsx';
import FixingFrequency from '@/App/tiles/ForwardAccumulator/parts/RightPanel/common/FixingFrequency.tsx';
import LastFixingDate from '@/App/tiles/ForwardAccumulator/parts/RightPanel/common/LastFixingDate.tsx';
import SettlementFrequency from '@/App/tiles/ForwardAccumulator/parts/RightPanel/common/SettlementFrequency.tsx';

export const InputGroup3 = ({ useShortLabels = false }: { useShortLabels?: boolean }) => (
  <>
    <FirstFixingDate />
    <LastFixingDate />
    <FixingFrequency />
    <SettlementFrequency useShortLabel={useShortLabels} />
  </>
);
